module.exports = __webpack_public_path__ + "static/media/09.7de2344e.png";